import type { LoginBehaviorProfile } from '@terra/shared-contracts-applications';
import type { LoginBehaviorConfigurationValue } from './LoginBehaviorConfiguration';

export const toLoginBehaviorConfigurationValue = (
  profile: LoginBehaviorProfile | null | undefined,
): LoginBehaviorConfigurationValue => ({
  concurrentSessions: profile?.concurrentSessions?.value ?? 'UNKNOWN',
  logoutScope: profile?.logoutScope?.value ?? 'UNKNOWN',
  tokenRotation: profile?.tokenRotation?.value ?? 'UNKNOWN',
  maxParallelLogins: profile?.maxParallelLogins?.value ?? null,
});
